// Vue
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Components
import { Modal } from "../modal/Modal";
import { Tabs } from "../tabs/Tabs";
import { Tab } from "../tabs/tab/Tab";
import { CookieSettings } from "../cookie/cookie_settings/CookieSettings";
import { Icon } from "../icon/Icon";

declare var process: {
  env: {
    NODE_ENV: string;
  };
};

@Component({
  components: {
    Modal,
    MgsTabs: Tabs,
    MgsTab: Tab,
    CookieSettings,
    MgsIcon: Icon,
  },
  mixins: [template],
})
export class PrivacyPolicy extends Vue {
  private alreadyLoadedPages: any = {};

  private loadingComplete: any = {
    anbieter: false,
    "rechtliche-hinweise": false,
    cookies: false,
    datenschutz: false,
    lizenzhinweise_dritter: false,
  };

  @Prop({ default: "anbieter" })
  public activeTab!: string;

  @Prop({ default: false })
  public visible!: boolean;

  @Prop({ default: "" })
  public baseUrl!: string;

  @Prop()
  public anbieterUrl!: string;

  @Prop()
  public rechtlicheHinweiseUrl!: string;

  @Prop()
  public cookiesUrl!: string;

  @Prop()
  public datenschutzUrl!: string;

  @Prop()
  public lizenzhinweiseDritterUrl!: string;

  @Prop({ default: "en" })
  public language!: string;

  @Watch("activeTab")
  private watchActiveTab(newActiveTab: string, oldActiveTab: string) {
    this.handleSetLoadedPage(newActiveTab);
  }

  @Watch("visible")
  private watchVisible(newVisible: boolean, oldVisible: boolean) {
    this.handleSetLoadedPage(this.activeTab);
  }

  public created() {}

  public handleClose(e) {
    this.$emit("update:visible", false);
  }

  public handleFrameResize(tabName: string, e: any) {
    this.loadingComplete[tabName] = true;
    if (process.env.NODE_ENV == "production")
      this.$nextTick(() => (e.target.style.height = e.target.contentWindow.document.body.scrollHeight + "px"));
  }

  public handleActiveTabChanged(newActiveTabName: string) {
    this.$emit("update:activeTab", newActiveTabName);

    this.handleSetLoadedPage(newActiveTabName);
  }

  private handleSetLoadedPage(name: string) {
    console.log(name);
    if (!this.alreadyLoadedPages[name]) this.alreadyLoadedPages[name] = true;
  }
}
